import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import es from "./locales/es.json";
import ja from "./locales/ja.json";
import pt from "./locales/pt.json";
import fr from "./locales/fr.json";
import it from "./locales/it.json";
import zh from "./locales/zh.json";
import ar from "./locales/ar.json";
import hi from "./locales/hi.json";
import de from "./locales/de.json";
import nl from "./locales/nl.json";

// TODO: re-enable multi-locale support. Only English is active for now; non-English
// locales redirect to /en via LocaleProvider. Full list preserved below for revival.
// export const SUPPORTED_LOCALES = ["en", "es", "ja", "pt", "fr", "it", "zh", "ar", "hi", "de", "nl"] as const;
export const SUPPORTED_LOCALES = ["en"] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const LOCALE_LABELS: Record<SupportedLocale, string> = {
  en: "English",
  // es: "Español",
  // ja: "日本語",
  // pt: "Português",
  // fr: "Français",
  // it: "Italiano",
  // zh: "中文",
  // ar: "العربية",
  // hi: "हिन्दी",
  // de: "Deutsch",
  // nl: "Nederlands",
};

/** Locales that should render right-to-left. */
export const RTL_LOCALES: string[] = ["ar"];

export function isRTL(locale: string): boolean {
  return RTL_LOCALES.includes(locale as SupportedLocale);
}

export function isSupportedLocale(locale: string): locale is SupportedLocale {
  return SUPPORTED_LOCALES.includes(locale as SupportedLocale);
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
    ja: { translation: ja },
    pt: { translation: pt },
    fr: { translation: fr },
    it: { translation: it },
    zh: { translation: zh },
    ar: { translation: ar },
    hi: { translation: hi },
    de: { translation: de },
    nl: { translation: nl },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
